import { Outlet } from "react-router-dom"

export const StudentLayout = () => {
    return <Outlet/>;
}